export * from './breadcrumb-item';

import { BreadcrumbItemComponent } from './breadcrumb-item';

export const BreadcrumbAtoms = [
    BreadcrumbItemComponent
]